import { useEffect, useState } from "react";
import { http, fmtINR, fmtNum } from "@/lib/api";

const STATUS_STYLES = {
    Draft: "bg-slate-500/10 text-slate-600 border-slate-500/30",
    Approved: "bg-blue-500/10 text-blue-600 border-blue-500/30",
    Dispatched: "bg-amber-500/10 text-amber-600 border-amber-500/30",
    Delivered: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30",
    Cancelled: "bg-red-500/10 text-red-600 border-red-500/30",
};

export default function SellIn() {
    const [orders, setOrders] = useState([]);
    useEffect(() => {
        http.get("/sellin/orders", { params: { limit: 200 } }).then((r) => setOrders(r.data));
    }, []);

    const totalVal = orders.reduce((s, o) => s + (o.total_value || 0), 0);
    const totalQty = orders.reduce((s, o) => s + (o.total_qty || 0), 0);

    return (
        <div className="mx-auto max-w-[1560px] space-y-4 p-6">
            <div className="flex items-end justify-between">
                <div>
                    <div className="mlabel">Sell-In</div>
                    <h1 className="text-[22px] font-semibold tracking-tight">Distributor Orders & Dispatch</h1>
                </div>
                <div className="text-[11px] text-muted-foreground">
                    {fmtNum(orders.length)} orders · {fmtINR(totalVal)} value
                </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
                <Stat label="Orders" value={fmtNum(orders.length)} />
                <Stat label="Units Ordered" value={fmtNum(totalQty)} />
                <Stat label="Order Value" value={fmtINR(totalVal)} />
            </div>

            <div className="overflow-hidden rounded-sm border border-border bg-card" data-testid="sellin-table">
                <div className="max-h-[calc(100vh-300px)] overflow-auto">
                    <table className="w-full text-[12px]">
                        <thead className="sticky top-0 z-10 bg-muted/60 text-[10px] uppercase tracking-wider text-muted-foreground">
                            <tr>
                                <th className="px-3 py-2 text-left font-semibold">Order No.</th>
                                <th className="px-3 py-2 text-left font-semibold">Distributor</th>
                                <th className="px-3 py-2 text-left font-semibold">Region</th>
                                <th className="px-3 py-2 text-left font-semibold">Date</th>
                                <th className="px-3 py-2 text-right font-semibold">Lines</th>
                                <th className="px-3 py-2 text-right font-semibold">Qty</th>
                                <th className="px-3 py-2 text-right font-semibold">Value</th>
                                <th className="px-3 py-2 text-left font-semibold">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((o) => (
                                <tr
                                    key={o.id}
                                    data-testid={`sellin-row-${o.id}`}
                                    className="border-t border-border hover:bg-muted/40"
                                >
                                    <td className="mono-num px-3 py-1.5 font-medium">{o.order_no}</td>
                                    <td className="px-3 py-1.5">{o.distributor?.name || "—"}</td>
                                    <td className="px-3 py-1.5 text-muted-foreground">{o.distributor?.region || "—"}</td>
                                    <td className="mono-num px-3 py-1.5 text-muted-foreground">
                                        {o.order_date?.slice(0, 10)}
                                    </td>
                                    <td className="mono-num px-3 py-1.5 text-right">{o.lines?.length || 0}</td>
                                    <td className="mono-num px-3 py-1.5 text-right">{fmtNum(o.total_qty)}</td>
                                    <td className="mono-num px-3 py-1.5 text-right font-semibold">
                                        {fmtINR(o.total_value)}
                                    </td>
                                    <td className="px-3 py-1.5">
                                        <span
                                            className={
                                                "rounded-sm border px-1.5 py-[1px] text-[10px] font-medium " +
                                                (STATUS_STYLES[o.status] || "")
                                            }
                                        >
                                            {o.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="rounded-sm border border-border bg-card p-3">
            <div className="mlabel">{label}</div>
            <div className="mono-num mt-1 text-xl font-semibold">{value}</div>
        </div>
    );
}
